
import { nav } from './nav';
import { auth } from './auth';
import { landing } from './landing';
import { assessment } from './assessment';
import { profile, chart, traits, personality } from './profile';
import { professional, workStyle, communication } from './profile/professional';
import { words } from './words';
import { cognitive } from './cognitive';
import { profiles } from './profiles';
import { buttons, language, userForm, errors, common } from './common';
import { results, factors, insights, tabs, professional as resultsProfessional, objectivity } from './results';
import { training } from './training';

export const en = {
  nav,
  buttons,
  language,
  userForm,
  auth,
  landing,
  assessment,
  profile,
  chart,
  traits,
  personality,
  professional,
  workStyle,
  communication,
  results,
  factors,
  insights,
  tabs,
  errors,
  common,
  words,
  cognitive,
  profiles,
  objectivity,
  training
};
